import React from 'react';
import { motion } from 'framer-motion';
import { media } from '../data/media';
import { useLanguage } from '../contexts/LanguageContext';
const container = {
  hidden: {},
  show: {
    transition: {
      staggerChildren: 0.12,
      delayChildren: 0.1
    }
  }
};
const fadeUp = {
  hidden: {
    opacity: 0,
    y: 24
  },
  show: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.8,
      ease: [0.22, 1, 0.36, 1] as const
    }
  }
};
const showcase = [{
  src: media.alfajores,
  alt: 'Alfajores péruviens enrobés de chocolat blanc, pacanes et canneberges',
  className: 'col-span-2 aspect-[16/10]'
}, {
  src: media.bonbonsCoeurs,
  alt: 'Bonbons cœurs peints à la main, garnis de ganache',
  className: 'aspect-square'
}, {
  src: media.bonbonsVerts,
  alt: 'Bonbons marbrés verts au cœur de praliné',
  className: 'aspect-square'
}];
export function HeroSection() {
  const {
    t
  } = useLanguage();
  return <section id="accueil" className="relative bg-cacao-900 px-6 pb-20 pt-40 md:px-12 md:pb-28 md:pt-44" data-id="element-109" data-mp="3ka35rhl61czb">
      <div className="mx-auto grid max-w-7xl items-center gap-14 lg:grid-cols-2 lg:gap-20" data-id="element-110" data-mp="2ffs1jg2s7cv7">
        <motion.div variants={container} initial="hidden" animate="show" className="text-center lg:text-left" data-id="element-111" data-mp="2bfhv62b2ukft">
          <motion.img variants={fadeUp} src={media.logo} alt="Les Artisans Sucrés — Chocolaterie & Alfajores artisanales" className="mx-auto mb-9 h-36 w-36 rounded-full border-2 border-or/50 object-cover shadow-lg md:h-44 md:w-44 lg:mx-0" data-id="element-112" data-mp="2ked3pl1lg6ma" />

          <motion.span variants={fadeUp} className="mb-5 block font-sans text-[11px] uppercase tracking-[0.28em] text-caramel-light md:text-xs" data-id="element-113" data-mp="384fsnsa7owgo">
            {t.hero.eyebrow}
          </motion.span>

          <motion.h1 variants={fadeUp} className="mb-4 font-serif text-4xl leading-[1.1] text-creme md:text-5xl" data-id="element-114" data-mp="1dqokkx7j6knc">
            {t.hero.titleLead}
          </motion.h1>

          <motion.p variants={fadeUp} className="mb-6 font-serif text-2xl italic text-caramel-light md:text-3xl" data-id="element-115" data-mp="38v5uh3jo3ur0">
            {t.hero.titleAccent}
          </motion.p>

          <motion.p variants={fadeUp} className="mx-auto mb-10 max-w-xl font-sans text-base font-light leading-relaxed text-creme/80 md:text-lg lg:mx-0" data-id="element-116" data-mp="3iq7ke1lrp0un">
            {t.hero.subtitle}
          </motion.p>

          <motion.div variants={fadeUp} className="flex flex-col items-center gap-4 sm:flex-row sm:justify-center lg:justify-start" data-id="element-117" data-mp="lmcpgu7993q">
            <a href="#creations" className="w-full bg-caramel px-8 py-4 text-center font-sans text-xs uppercase tracking-[0.16em] text-creme transition-colors duration-300 hover:bg-caramel-light sm:w-auto" data-id="element-118" data-mp="5ep8zwqd2wnm">
              {t.hero.ctaPrimary}
            </a>
            <a href="#cacao" className="w-full border border-caramel-light px-8 py-4 text-center font-sans text-xs uppercase tracking-[0.16em] text-caramel-light transition-colors duration-300 hover:border-creme hover:text-creme sm:w-auto" data-id="element-119" data-mp="jaaz678bzmhm">
              {t.hero.ctaSecondary}
            </a>
          </motion.div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 32
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.9,
        delay: 0.35,
        ease: [0.22, 1, 0.36, 1]
      }} className="border border-or/40 p-3 md:p-4" data-id="element-120" data-mp="1pw7zondk3539">
          <div className="grid grid-cols-2 gap-3 md:gap-4" data-id="element-121" data-mp="2dscavvytthgr">
            {showcase.map(photo => <div key={photo.alt} className={`overflow-hidden ${photo.className}`} data-id="element-122" data-mp="28tr7jnoa2ho3">
                <img src={photo.src} alt={photo.alt} className="h-full w-full object-cover transition-transform duration-700 hover:scale-105" data-id="element-123" data-mp="368wqdj06sus0" />
              </div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}